import Markdown from 'markdown-to-jsx';

const MarkdownRenderer = (props: {
  markdown: string
}) => {
  return <Markdown>{props.markdown}</Markdown>;
};

export default MarkdownRenderer;